import { Component, Prop, h, Element, Fragment, State } from '@stencil/core';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

@Component({
  tag: 'qumra-slider',
  styleUrl: 'qumra-slider.css',
  shadow: false,
})
export class QumraSlider {
  @Element() el: HTMLElement;
  @Prop() slides: { content: string }[] = [];
  @Prop() navigationColor: string = "#000";
  @Prop() navigation: boolean = true;
  @Prop() pagination: boolean = false;
  @Prop() centered: boolean = false;
  @Prop() spaceBetweenSlide: string = "30";
  @State() uniqueId: string = `qumra-slider-${Math.random().toString(36).substr(2, 9)}`;

  componentDidLoad() {
    const swiper = new Swiper(`.${this.uniqueId} .mySwiper`, {
      loop: true,
      modules: [Navigation,Pagination],
      centeredSlides: this.centered,
      slidesPerView: this.centered ? 1.2 :1,
      spaceBetween: parseInt(this.spaceBetweenSlide),
      pagination: {
        el: `.${this.uniqueId} .swiper-pagination`, // تأكد من وجود هذا العنصر
        clickable: true, // لتفعيل القدرة على النقر على النقاط
      },
      navigation: {
        nextEl: `.${this.uniqueId} .swiper-button-next`,
        prevEl: `.${this.uniqueId} .swiper-button-prev`,
      },
    });

    swiper.on('changeDirection', () => {
    });
    swiper.on('init', () => {
    });
  }

  hexToRgb(hex: string) {
    hex = hex.replace('#', '');
    if (hex.length === 3) {
      hex = hex.split('').map(x => x + x).join('');
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return {
      r: isNaN(r) ? 0 : r,
      g: isNaN(g) ? 0 : g,
      b: isNaN(b) ? 0 : b
    };
  }

  lightenColor(rgb: { r: number; g: number; b: number }, percentage: number) {
    return {
      r: Math.round(rgb.r + (255 - rgb.r) * percentage),
      g: Math.round(rgb.g + (255 - rgb.g) * percentage),
      b: Math.round(rgb.b + (255 - rgb.b) * percentage),
    };
  }

  render() {
    const rgbColor = this.hexToRgb(this.navigationColor);
    const lightenedColor = this.lightenColor(rgbColor, 0.9);
    const lightenedBadgeColor = `rgb(${lightenedColor.r}, ${lightenedColor.g}, ${lightenedColor.b})`;

    return (
      <div class={`swiper-container ${this.uniqueId}`}>
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <slot></slot>
          </div>
        </div>

        {this.navigation && (
          <Fragment>
            <button aria-label="UInavigation-swiper-button-next" class={`${this.uniqueId} swiper-button-next`} style={{ backgroundColor: lightenedBadgeColor }}>
              <span style={{ color: this.navigationColor }}>
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.65115 18.2238C8.30664 17.8655 8.31781 17.2958 8.67611 16.9512L13.4014 12.5L8.67611 8.04875C8.31781 7.70424 8.30664 7.1345 8.65115 6.7762C8.99567 6.41791 9.56541 6.40674 9.9237 6.75125L15.3237 11.8512C15.5002 12.0209 15.5999 12.2552 15.5999 12.5C15.5999 12.7448 15.5002 12.9791 15.3237 13.1487L9.9237 18.2487C9.56541 18.5933 8.99567 18.5821 8.65115 18.2238Z"
                   fill={this.navigationColor} stroke={this.navigationColor} stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
            <button aria-label="UInavigation-swiper-button-prev" class={`.${this.uniqueId} swiper-button-prev`} style={{ backgroundColor: lightenedBadgeColor }}>
              <span style={{ color: this.navigationColor }}>
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3488 6.7762C15.6934 7.1345 15.6822 7.70424 15.3239 8.04875L10.5986 12.5L15.3239 16.9513C15.6822 17.2958 15.6934 17.8655 15.3488 18.2238C15.0043 18.5821 14.4346 18.5933 14.0763 18.2487L8.6763 13.1488C8.49983 12.9791 8.4001 12.7448 8.4001 12.5C8.4001 12.2552 8.49983 12.0209 8.6763 11.8513L14.0763 6.75125C14.4346 6.40674 15.0043 6.41791 15.3488 6.7762Z"
                    fill={this.navigationColor} stroke={this.navigationColor} stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
          </Fragment>
        )}
           {this.pagination && (
    <div class={`${this.uniqueId} swiper-pagination`}></div>
        )}
      </div>
    );
  }
}